import { defineSlotRecipe } from '@chakra-ui/react';

export const statusSlotRecipe = defineSlotRecipe({
  slots: ['root', 'indicator'],
  base: {
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '2',
    },
    indicator: {
      width: '2',
      height: '2',
      borderRadius: 'full',
      flexShrink: 0,
    },
  },
  variants: {
    colorPalette: {
      gray: {
        indicator: {
          bg: 'neutral.250',
        },
      },
      red: {
        indicator: {
          bg: 'red.500',
        },
      },
      orange: {
        indicator: {
          bg: 'orange.500',
        },
      },
      green: {
        indicator: {
          bg: 'green.500',
        },
      },
      blue: {
        indicator: {
          bg: 'blue.500',
        },
      },
    },
  },
  defaultVariants: {
    colorPalette: 'gray',
  },
});
